var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.cats),function(category){return _c('v-col',{key:category,attrs:{"cols":"12","md":"6"}},[_c('app-cat-datatable',{attrs:{"reporting-data":_vm.reportingData[category],"category":category,"loading":_vm.loading},on:{"filter":_vm.filter}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }